/* eslint-disable @typescript-eslint/naming-convention */
import { ParameterInfos } from 'ut-business/parameter';

export const beamsParameters: Record<string, ParameterInfos> = {
  Selected_Beam: {
    metric: {
      unit: '',
      limit: {
        min: 1,
        max: 256,
      },
      defaultStep: 1,
      steps: [
        1,
      ],
    },
    imperial: {
      unit: '',
      limit: {
        min: 1,
        max: 256,
      },
      defaultStep: 1,
      steps: [
        1,
      ],
    },
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: false,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
